const destinationSubpath = '/destinations'

export const planRoutes = [
  {
    path: `${destinationSubpath}`,
    name: 'Destinations',
    meta: { showFooter: true, showHeader: true },
    component: () =>
      import(
        /* webpackChunkName: "destinations" */ '@/views/destinations/Index.vue'
      )
  },
  {
    path: `${destinationSubpath}/:slug`,
    name: 'Destination',
    meta: { showFooter: true, showHeader: true },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "destinations" */ '@/views/destinations/Show.vue'
      )
  }
]
